import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { AccountPurposeBreadcrumb } from '../../../../../../features/registration/account/account-purpose-breadcrumb';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account')({
  loader: ({ params }) =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'account-purpose',
        label: <AccountPurposeBreadcrumb accountId={params.accountId} />,
      }),
    }) satisfies AggregateBreadcrumb,
});
